<!-- Header Section -->
<header class="header">
  <div class="logo">Kiko VPN</div>
  <nav class="navigation">
      <a href="/home">Home</a>
      <a href="/downloads">Downloads</a>
      <a href="/privacy">Privacy</a>
      <a href="/terms">Terms</a>
      <a href="/reseller">Reseller</a>
      <a href="/faq">Faq</a>
      <a href="/support">Support</a>
      <a href="/about">About Us</a>
  </nav>
</header>
<div class="contact-form-container">
    <h2>Contact Support</h2>
    <form #contactForm="ngForm" (ngSubmit)="submitForm(contactForm)">
      <div class="form-group">
        <label for="name">Your Name:</label>
        <input type="text" id="name" name="name" ngModel required />
      </div>
  
      <div class="form-group">
        <label for="email">Your Email:</label>
        <input type="email" id="email" name="email" ngModel required />
      </div>
  
      <div class="form-group">
        <label for="message">Your Message:</label>
        <textarea id="message" name="message" ngModel required></textarea>
      </div>
  
      <button type="submit" [disabled]="!contactForm.valid">Submit</button>
    </form>
  </div>